// extracted by css-extract-rspack-plugin
export default {"promptContainer":"promptContainer-yqJFqV","prompt":"prompt-_tnwMo","promptText":"promptText-fVvvbb","actionButton":"actionButton-dHv2iq"};